module.exports = __webpack_public_path__ + "static/img/logo.f3e78f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shilin/logo.png
// module id = bJ8z
// module chunks = 71